<div class="NgxEditor__Wrapper" [style.border]="disabled ? 'none' : null">
    <ngx-editor-menu *ngIf="!disabled" [editor]="editor" [toolbar]="toolbar" [customMenuRef]="imageMenu"></ngx-editor-menu>
    <ngx-editor
            [editor]="editor"
            [(ngModel)]="html"
            [placeholder]="placeholder"
            [disabled]="disabled"
            (ngModelChange)="onContentChange($event)">
    </ngx-editor>
</div>

<ng-template #imageMenu>
    <div class="NgxEditor__MenuItem NgxEditor__MenuItem--Button img-insert-wrapper" style="position:relative;display:inline-block;">
        <div class="NgxEditor__MenuItem NgxEditor__MenuItem--Button"
             title="Insert Image"
             style="padding:0 6px;cursor:pointer;font-size:12px;white-space:nowrap;line-height:24px;"
             (mousedown)="toggleImgPanel($event)">
            🖼 Image
        </div>
        <div *ngIf="imgPanelOpen"
             style="position:absolute;top:calc(100% + 2px);left:0;z-index:200;
                    background:#fff;border:1px solid #ccc;border-radius:4px;
                    padding:10px;width:260px;
                    box-shadow:0 4px 12px rgba(0,0,0,.15);font-family:sans-serif;">
            <div style="margin-bottom:8px">
                <label style="font-size:11px;font-weight:600;display:block;margin-bottom:3px">Image URL</label>
                <input type="text" [(ngModel)]="imgUrl" placeholder="https://example.com/image.jpg"
                       style="width:100%;box-sizing:border-box;padding:5px 7px;
                              border:1px solid #ccc;border-radius:3px;font-size:12px;">
            </div>
            <div style="margin-bottom:10px">
                <label style="font-size:11px;font-weight:600;display:block;margin-bottom:3px">Width</label>
                <select [(ngModel)]="imgWidth"
                        style="width:100%;padding:5px 7px;border:1px solid #ccc;border-radius:3px;font-size:12px;">
                    <option value="25">25%</option>
                    <option value="33">33%</option>
                    <option value="50">50%</option>
                    <option value="75">75%</option>
                    <option value="100">100%</option>
                </select>
            </div>
            <div style="display:flex;gap:6px">
                <button (mousedown)="insertImage($event)"
                        style="flex:1;padding:5px;background:#0d6efd;color:#fff;
                               border:none;border-radius:3px;cursor:pointer;font-size:12px;">
                    Insert
                </button>
                <button (mousedown)="closeImgPanel()"
                        style="flex:1;padding:5px;background:#6c757d;color:#fff;
                               border:none;border-radius:3px;cursor:pointer;font-size:12px;">
                    Cancel
                </button>
            </div>
        </div>
    </div>
</ng-template>
